import React, { useState, useEffect, forwardRef } from 'react';
import './modal-schedules.scss';
import { Modal, ModalHeader, ModalBody, Jumbotron, Input, FormFeedback, Label } from 'reactstrap';
import { Schedule } from 'components';
import { GetUniquePhone, UpdatePhoneService, InputValidation } from 'services';
import * as yup from 'yup';
import { formatPhone } from 'helpers';

const ReactstrapInputWrapper = forwardRef((props, ref) => {
  return <Input {...props} innerRef={ref} />;
});

export function ModalSchedules({ isOpen, toggleModal, idContact, close, update }) {
  const populateObject = (invalid, message) => {
    return {
      invalid,
      message,
    };
  };

  const [phone, setPhone] = useState(populateObject(false, ''));

  const toggle = () => toggleModal(!isOpen);

  const phoneSchema = yup.object().shape({
    phone: yup
      .string()
      .matches(/^(\(\d{2}\) (9?\d{4})-\d{4})|((\(1[2-9]{1}\)|\([2-9]{1}\d{1}\)) [5-9]\d{3}-\d{4})$/)
      .required(),
  });

  const phoneFormData = {
    phone: phone.value,
  };

  const getPopulateObject = (input, value) => {
    const inputs = {
      phone: () => {
        setPhone(populateObject(true, value));
      },
    };

    return inputs[input] ? inputs[input]() : updatePhone();
  };

  const getValidation = async () => {
    const feedback = await Promise.resolve(
      InputValidation({
        schema: phoneSchema,
        formdata: phoneFormData,
      })
    ).then((value) => value);

    if (feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index]);
      });
    }

    return getPopulateObject(feedback?.id);
  };

  useEffect(() => {
    GetUniquePhone(idContact).then((contact) => {
      const formattedPhone = formatPhone(contact?.phoneNumber);

      setPhone({ value: formattedPhone });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idContact, isOpen]);

  const updatePhone = () => {
    UpdatePhoneService(idContact, phone.value).then(() => {
      update();
      close();
    });
  };

  function onChangePhone(e) {
    const formattedPhone = formatPhone(e.target.value);

    setPhone({ value: formattedPhone });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} className={'modal-schedules'}>
      <ModalHeader toggle={toggle}>Configurar horários</ModalHeader>

      <ModalBody>
        <Jumbotron>
          <Label>Telefone:</Label>

          <ReactstrapInputWrapper value={phone.value} placeholder="(99) 99999-9999" invalid={phone.invalid} onChange={onChangePhone} />

          <FormFeedback> {phone.message} </FormFeedback>
        </Jumbotron>
      </ModalBody>

      <ModalBody>
        <Schedule idContact={idContact} trigger={getValidation} />
      </ModalBody>
    </Modal>
  );
}
